import { z } from "zod";
import { ClientId, DateSchema } from "../../Types";
import { GoalBasedFinancialPlanIdSchema } from "../ids";
import { GoalBasedPlanDateResponse } from "../types";
export const GoalBasedFinancialPlanRetirementHorizonResponseSchema = z.object({
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    owner: ClientId,
    startDate: GoalBasedPlanDateResponse.optional(),
    endDate: GoalBasedPlanDateResponse.optional(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
//# sourceMappingURL=types.js.map